import PropTypes from 'prop-types';
import { Tracking } from 'components/seo/tracking/tracker';
import { useEffect } from 'react';

const SeoTracking = ({ templateName }) => {
    useEffect(() => {
        if (!window) {
            return;
        }

        window.__GLOBAL_CECA = window.__GLOBAL_CECA || {};
        window.defer_until(function () {
            return window.Cookies !== undefined;
        }, function () {
            Tracking({
                button_selector: '.button-to-track',
                default_utms: { utm_medium: 'organic', utm_campaign: templateName }
            });
        });
    }, [templateName]);

    return null;
};

SeoTracking.propTypes = {
    templateName: PropTypes.string
};

export default SeoTracking;
